<h1 mat-dialog-title>
  <span style="color: #358150;">
    SUCCESS!
  </span>
</h1>

<div mat-dialog-content>

  <p *ngIf="!wasResubmit">
    You have successfully submitted your application.
  </p>

  <p *ngIf="wasResubmit">
    Thank you for correcting the required documents and/or photos. Your application has been resubmitted for review.
  </p>

  <p>
    EBB will review your application and let you know if any additional action is required.
  </p>

</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-raised-button
    color="primary"
    (click)="onClickClose()">
    CLOSE
  </button>
</div>